export function flattenObject(obj: object) {
  const object = {};
  const path = [];

  function dig(obj2: object) {
    if (!obj2) return;
    Object.entries(obj2).forEach(([key, value]) => {
      path.push(key);
      if (typeof value === 'object') dig(value);
      else object[path.join('.')] = value;
      path.pop();
    });
  }

  dig(obj);
  return object;
}

export default flattenObject;
